import React from "react";
import "./index.css";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "./lib/api";
import Home from "./pages/Home";
import Admin from "./pages/Admin";

function App() {
    return (
        <ThemeProvider>
            <div className="App">
                <Toaster position="bottom-right" theme="dark" richColors />
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </ThemeProvider>
    );
}

export default App;
